module.exports = __webpack_public_path__ + "img/revert.44de8490.svg";